import api from '../../services/api';
import type { ManualData, ManualDataDTO } from '../../shared/interfaces/manual';
import type { ScreenData } from '../../shared/interfaces/screen';

const PopulateFaqScreens = async (
  faqDTOs: ManualDataDTO[],
): Promise<ManualData[]> => {
  const responseScreen = await api.get(`/tela`);

  let faqs: ManualData[] = [];
  for (let index = 0; index < faqDTOs.length; index++) {
    const faqDTO = faqDTOs[index];

    let faq: ManualData = {
      key: faqDTO.key,
      id: faqDTO.id,
      file: faqDTO.file,
      nomeManual: faqDTO.nomeManual,
      tituloArquivo: faqDTO.tituloArquivo,
      readableSize: faqDTO.readableSize,
      listaDeTelas: faqDTO.listaDeTelas,
      nomeRepositorio: faqDTO.nomeRepositorio,
      identificadorArquivoRepositorio: faqDTO.identificadorArquivoRepositorio,
    };

    faq.listaDeTelas = responseScreen.data.filter(
      (s: ScreenData) =>
        faqDTO && faqDTO.listaDeTelas && faqDTO.listaDeTelas.includes(s.id),
    );

    faqs.push(faq);
  }

  return faqs;
};

export default PopulateFaqScreens;
